import { upsellElements } from './upsellElements';

export const prepareUpsellStyles = (upsellProductId: string) => {
  const { upsellWrapper } = upsellElements();

  const productWrapperArray = (upsellWrapper.querySelectorAll(
    '[role="listitem"]'
  ) as unknown) as HTMLElement[];

  let productWrapperDisplay;

  //We have to search for all styles in case upsell has already been shown
  for (let i = 0; i < productWrapperArray.length; i++) {
    const element = productWrapperArray[i];
    const style = window.getComputedStyle(element);

    const display = style.display;

    if (display !== 'none') {
      productWrapperDisplay = display;
      break;
    }
  }

  // set all productWrappers to display none
  productWrapperArray.forEach((element) => (element.style.display = 'none'));

  //Find the right productWrapper

  const productFormArray = upsellWrapper.querySelectorAll(
    `[data-node-type="commerce-add-to-cart-form"][data-commerce-product-id="${upsellProductId}"]`
  );

  const productForm = productFormArray[0];

  const productWrapper = productForm.closest(
    '[role="listitem"]'
  ) as HTMLElement;

  //Apply old style
  if (productWrapperDisplay) {
    productWrapper.style.display = productWrapperDisplay;
  }

  let stylesSet = false;

  if (productForm) {
    stylesSet = true;
  }

  return stylesSet;
};
